import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;

  .ant-form-item {
    margin: 0;
  }
`;
